import styled from 'styled-components';
import {IconButton} from "@mui/material";
import {tokens} from "../../../../../theme";


export const SidebarProfileContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    gap: 10px;
    width: 100%;
    height: 40px;

    img {
        width: 40px;
        height: 40px;
        border-radius: 40px;
    }
`;

export const SidebarProfileMoreBtn = styled(IconButton)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0;
    gap: 4px;
    width: 28px;
    height: 28px;
    border-radius: 12px;

    img {
        width: 4px;
        height: 20px;
    }
    
    svg {
        color: ${({theme}) => theme.palette.text.primary};
    }
`;

export const SidebarProfileAvatarImg = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
`;

export const SidebarProfileAvatarFallback = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: ${tokens.colors.blue600};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({theme}) => theme.palette.primary.contrastText};
    font-size: 16px;
    font-weight: bold;
`;
